import {
    Grid,
    TableContainer,
    Table,
    TableHead,
    TableCell,
    TableRow,
    Paper,
    TableBody,
    Typography
} from '@mui/material';

const CB_BATCH_VOLUME_HEADERS = [
    'Project ID',
    'Batch ID',
    'CB ID',
    'Bucket Volume',
    'Partially Unburnt Volume',
    'Unit'
]

export default function CbBatchVolumes({ batchData }) {
    return (
        <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Typography variant="h5">
                Batch Volumes
            </Typography>
            <TableContainer component={Paper} sx={{ height: 'auto' }}>
                <Table aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            {CB_BATCH_VOLUME_HEADERS.map((header) => (
                                <TableCell
                                    key={header}
                                    align='left'>
                                    {header}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {batchData?.map((bd, index) => (
                            <TableRow key={index}>
                                <TableCell align="left">{bd.projectId}</TableCell>
                                <TableCell align="left">{bd.batchId}</TableCell>
                                <TableCell align="left">{bd.cbId}</TableCell>
                                <TableCell align="left">{bd.bucketVolume.toFixed(3)}</TableCell>
                                <TableCell align="left">{bd.partiallyBurntVolume.toFixed(3)}</TableCell>
                                <TableCell align="left">{bd.unit}</TableCell>
                            </TableRow>
                        )
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        </Grid>
    )
}
